import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Mic2, Trophy, Flame } from "lucide-react";
import { motion } from "framer-motion";

export default function ComediansPage() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/comedians").then(({ data }) => setList(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 pb-24 md:pb-12">
      <div className="mb-8">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#00F0FF]/40 bg-[#00F0FF]/10 px-3 py-1 text-[10px] font-mono-ui uppercase tracking-widest text-[#00F0FF]">
          <Mic2 className="h-3 w-3" />
          Comedian Rankings
        </div>
        <h1 className="mt-4 font-display text-5xl text-white">HALL OF <span className="text-amber-400">LAUGHS</span></h1>
        <p className="mt-2 text-slate-400">Comedians ranked by community upvotes across all their clips.</p>
      </div>

      {loading ? (
        <div className="space-y-3">
          {Array.from({ length: 6 }).map((_, i) => <div key={i} className="h-20 animate-pulse rounded-lg bg-white/5" />)}
        </div>
      ) : list.length === 0 ? (
        <div className="rounded-xl border border-dashed border-white/10 p-16 text-center">
          <p className="font-display text-2xl text-slate-400">No comedians yet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {list.map((c, i) => (
            <motion.div
              key={c.comedian}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.05 }}
              className="card-neon flex items-center gap-4 rounded-xl p-4"
              data-testid={`comedian-row-${i}`}
            >
              <div className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-full font-display text-2xl ${
                i === 0 ? "bg-amber-400 text-black glow-amber" :
                i === 1 ? "bg-slate-300 text-black" :
                i === 2 ? "bg-orange-400 text-black" :
                "bg-white/10 text-white"
              }`}>
                {i + 1}
              </div>
              <div className="flex-1 min-w-0">
                <Link
                  to={`/?comedian=${encodeURIComponent(c.comedian)}`}
                  className="font-display text-2xl text-white hover:text-amber-400 truncate block"
                >
                  {c.comedian}
                </Link>
                <p className="text-xs font-mono-ui uppercase tracking-widest text-slate-400 mt-0.5">
                  {c.clip_count} clip{c.clip_count !== 1 ? "s" : ""}
                </p>
              </div>
              <div className="flex gap-4 text-right shrink-0">
                <div>
                  <div className="font-display text-2xl text-amber-400">{c.total_upvotes}</div>
                  <div className="text-[9px] font-mono-ui uppercase tracking-widest text-slate-500">Upvotes</div>
                </div>
                <div className="hidden sm:block">
                  <div className="font-display text-2xl text-white flex items-center gap-1">
                    <Trophy className="h-4 w-4 text-amber-400" />{c.avg_elo}
                  </div>
                  <div className="text-[9px] font-mono-ui uppercase tracking-widest text-slate-500">Avg ELO</div>
                </div>
                <div className="hidden md:block">
                  <div className="font-display text-2xl text-[#FF2E55] flex items-center gap-1">
                    <Flame className="h-4 w-4" />{c.wins}
                  </div>
                  <div className="text-[9px] font-mono-ui uppercase tracking-widest text-slate-500">Wins</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
